import React from 'react';
import { wire } from 'react-hot-wire';
import BattlesService from 'services/battles/BattlesService';
import BrowserHistoryService from 'services/application/BrowserHistoryService';
import useGetBattleGroupList from 'components/battles/hook/api/useGetBattleGroupList';
import Loader from 'components/commons/_/loader/Loader';
import { FormattedMessage } from 'react-intl';

export type SelectGroupProps = {
	onSelect: (group: string) => void;
};
export type SelectGroupWiredProps = SelectGroupProps & {
	'services.battlesService': BattlesService;
	'services.browserHistoryService': BrowserHistoryService;
};

export const SelectGroup = ({
	onSelect,
	'services.browserHistoryService': browserHistoryService,
	...props
}: SelectGroupWiredProps) => {
	const battleGroupListQuery = useGetBattleGroupList(props);

	return (
		<div className="battlesSelectGroup">
			<div className="battlesSelectGroup__list">
				{battleGroupListQuery.isLoading ? (
					<div className="d-flex justify--center">
						<Loader fixed={false} />
					</div>
				) : (
					<>
						{battleGroupListQuery.data?.count === 0 ? (
							<div className="empty">
								<FormattedMessage id="battles.start-new-game.no-battle-groups" />
							</div>
						) : (
							battleGroupListQuery.data?.items.map(item => (
								<div
									className="battlesSelectGroup__list-element"
									onClick={event => {
										event.stopPropagation();
										onSelect(item.id);
									}}
								>
									{item.name}
								</div>
							))
						)}
					</>
				)}
			</div>
		</div>
	);
};

export default wire<SelectGroupWiredProps, SelectGroupProps>(
	['services.battlesService', 'services.browserHistoryService'],
	SelectGroup
);
